module.exports = __webpack_public_path__ + "assets/img/8ac2736410d7841a9402d4e9877b66d7.svg";